import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Table, Button } from 'react-bootstrap';
import FormTableHeading from './FormTableHeading';
import FormTableRow from './table/FormTableRow';
import FormTableSection from './table/FormTableSection';
import { withFormContext } from './FormContext';

const _ = { isEqual };

class FormTableBody extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.getDataIndex = this.getDataIndex.bind(this);
    this.formManager = props.context.manager;

    this.state = {
      key: 0,
    };

    this.recache();
  }

  shouldComponentUpdate(newProps) {
    const { form, currentIndex, collapsed } = this.props;

    if (currentIndex !== newProps.currentIndex) {
      return true;
    }

    if (collapsed !== newProps.collapsed) {
      return true;
    }

    for (const fieldName of Object.keys(newProps.form)) {
      // TODO Checkall hack, remove one day.  Checkboxes always re-render
      if (newProps.form[fieldName].control === 'checkbox') {
        return true;
      }

      // Rerender if there's any auto calculated field at all
      if (newProps.form[fieldName].calculated) {
        return true;
      }

      // Rerender if any validation states have changed
      if (!_.isEqual(newProps.form[fieldName].validIndex, form[fieldName].validIndex)) {
        return true;
      }

      // Rerender if the original values changed
      if (!_.isEqual(newProps.form[fieldName].originalValue, form[fieldName].originalValue)) {
        return true;
      }

      // Rerender if hiddenIndex changes
      if (
        !_.isEqual(newProps.form[fieldName].hiddenIndex, form[fieldName].hiddenIndex) ||
        newProps.form[fieldName].hidden !== form[fieldName].hidden
      ) {
        return true;
      }

      // Rerender if calculatedIndex changes
      if (
        !_.isEqual(newProps.form[fieldName].calculatedIndex, form[fieldName].calculatedIndex) ||
        newProps.form[fieldName].calculated !== form[fieldName].calculated
      ) {
        return true;
      }

      // Rerender if disabledIndex changes
      if (
        !_.isEqual(newProps.form[fieldName].disabledIndex, form[fieldName].disabledIndex) ||
        newProps.form[fieldName].disabled !== form[fieldName].disabled
      ) {
        return true;
      }

      // Rerender if touchedIndex changes
      if (!_.isEqual(newProps.form[fieldName].touchedIndex, form[fieldName].touchedIndex)) {
        return true;
      }

      // Rerender if optionsIndex changes
      // if (!_.isEqual(newProps.form[fieldName].optionsIndex, form[fieldName].optionsIndex)) {
      //   return true;
      // }
    }

    return false;
  }

  reload(cb = () => {}) {
    this.recache();
    this.forceUpdate(cb);
  }

  recache(withForm) {
    const { manager, form, currentIndex } = this.props;

    manager.masterForm = withForm || form;
    manager.setBoundaries(currentIndex);
    manager.checkDeps().cacheRowData();

    return manager.cachedRowData;
  }

  incrementKey(cb) {
    this.setState(prevState => ({ key: prevState.key + 1 }), cb);
  }

  getDataIndex(id) {
    const { manager } = this.props;
    return manager.rowIds[id];
  }

  /**
   * Change handler for any field in a collection.
   *
   * @param {String} fieldName - Name of the field.
   * @param {String} value - New value for the field.
   * @param {Number} dataIndex - Index for data. (Row)
   * @return
   */
  handleChange(fieldName, value, dataIndex, cb) {
    // console.debug(`Calling Collection handleChange on Field: '${fieldName}' Value: '${value}' Row: '${dataIndex}'`);
    const { manager } = this.props;

    manager.killCacheByDataIndex(dataIndex);

    const result = this.props.onRowChange(this.props.fieldNameList, dataIndex, fieldName, value, cb);
    const newForm = {};

    this.props.fieldNameList.forEach(name => {
      newForm[name] = result[name];
    });

    // manager.masterForm = newForm;

    setTimeout(() => {
      this.recache(newForm);
    }, 250);
  }

  handleBlur(fieldName, dataIndex, rowId) {
    const { manager } = this.props;
    manager.killCacheByRowId(rowId);
    return this.props.onBlur(fieldName, dataIndex, rowId);
  }

  /**
   * Determines if deleting a row is allowed.
   *
   * @return {Boolean}
   */
  canDelete() {
    const { canDelete, minSize, manager } = this.props;

    const { count } = manager.getCount();

    if (!canDelete || count <= minSize) {
      return false;
    }

    return true;
  }

  render() {
    const {
      baseColumns,
      canAdd,
      canInsert,
      className,
      currentIndex,
      form,
      manager,
      repeatHeaders,
      sections,
      collapse,
      collapsed,
    } = this.props;

    const [start, end] = manager.setBoundaries(currentIndex);
    const { count, filtered } = manager.getCount();
    this.recache();
    const rows = manager.cachedRowData;

    if (!count) {
      // All Rows are filtered
      if (filtered !== 0) {
        return (
          <tbody>
            <tr key="empty-table">
              <td colSpan={baseColumns.length + 2}>
                <div className="empty-table">All rows have been filtered</div>
              </td>
            </tr>
          </tbody>
        );
        // Empty table (could have rows marked for deletion)
      } else {
        return (
          <tbody>
            <tr key="empty-table">
              <td colSpan={baseColumns.length + 2}>
                <div className="empty-table">
                  Empty
                  <br />
                  {canAdd && (
                    <div className="add-control">
                      <Button variant="success" onClick={() => this.props.addItem()}>
                        <i className="zmdi zmdi-collection-plus zmdi-hc-lg" /> Add First Entry
                      </Button>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          </tbody>
        );
      }
    }

    const renderedBodies = [];
    const rowIds = manager.getRows();

    for (let index = start; index < end; index++) {
      const renderedRows = [];
      const rowId = rowIds[index];
      const rowData = rows[rowId];

      // TODO This should really not be possible
      if (rowId === undefined) {
        continue; // eslint-disable-line
      }

      const dataIndex = manager.rowIds[rowId];
      if (repeatHeaders && index !== start) {
        renderedBodies.push(
          <tbody
            className={classNames('header-repeat', { collapsed: collapsed[rowId] === true })}
            key={`head-${rowId}`}
          >
            <FormTableHeading
              key={`head-${rowId}`}
              columns={this.props.baseColumns}
              form={form}
              manager={manager}
              sortColumn={this.props.sortColumn}
              sortable={this.props.canSort}
            />
          </tbody>
        );
      }

      // Render normal collection
      renderedRows.push(
        <FormTableRow
          key={`row-${rowId}`}
          addItem={canAdd && canInsert && this.props.addItem}
          canDelete={this.canDelete()}
          collapse={collapse}
          collapsed={collapsed[rowId] === true}
          collapsibleRows={this.props.collapsibleRows}
          collapsibleText={this.props.collapsibleText}
          columns={this.props.baseColumns}
          dataIndex={dataIndex}
          form={rowData}
          getDataIndex={this.getDataIndex}
          index={index}
          numberedRows={this.props.numberedRows}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onClick={this.props.onClick}
          primary
          removeItem={this.props.removeItem}
          rowId={rowId}
          rowSpan={Object.keys(sections).length + 1}
          setInfo={this.props.setInfo}
          setWarning={this.props.setWarning}
        />
      );

      Object.keys(sections).forEach(sectionName => {
        // check to see if any fields in a section should show
        if (this.props.isSectionHidden(sectionName, dataIndex)) {
          renderedRows.push(<tr key={`row-${sectionName}-${rowId}`} className="hidden-section" />);
          return;
        }

        const sectionFields = this.formManager.layout.getAllFieldsUnderGroup(sectionName);
        const sectionConfig = sections[sectionName];

        renderedRows.push(
          <FormTableSection
            key={`row-${sectionName}-${rowId}`}
            controlId={`row-${sectionName}-${rowId}`}
            title={sectionConfig.label}
            columns={this.props.baseColumns.length}
            struct={sectionConfig.struct}
            className={sectionName}
          >
            <Table>
              <thead>
                {!this.props.isSectionHidden(sectionName, dataIndex) && (
                  <FormTableHeading
                    columns={sectionFields}
                    form={form}
                    hideInitialColumn
                    manager={manager}
                    sortColumn={this.props.sortColumn}
                    sortable={false}
                  />
                )}
              </thead>
              <tbody>
                <FormTableRow
                  key={`section-${rowId}`}
                  canDelete={this.canDelete()}
                  columns={sectionFields}
                  form={rowData}
                  getDataIndex={this.getDataIndex}
                  index={index}
                  insideSection={!!sectionName}
                  onBlur={this.handleBlur}
                  onChange={this.handleChange}
                  onClick={this.props.onClick}
                  removeItem={this.props.removeItem}
                  rowId={rowId}
                  setWarning={this.props.setWarning}
                />
              </tbody>
            </Table>
          </FormTableSection>
        );
      });

      renderedBodies.push(
        <tbody
          key={`row-${rowId}`}
          className={classNames(
            'data-body',
            { collapsed: collapsed[rowId] === true, even: index % 2 === 0 },
            className
          )}
        >
          {renderedRows}
        </tbody>
      );
    }

    return <React.Fragment key={this.state.key}>{renderedBodies}</React.Fragment>;
  }
}

FormTableBody.defaultProps = {
  addItem: () => {},
  baseColumns: [],
  canAdd: true,
  canDelete: true,
  canInsert: false,
  collapsed: {},
  collapsibleRows: false,
  currentIndex: 0,
  fieldNameList: [],
  isSectionHidden: false,
  limit: 10,
  minSize: null,
  numberedRows: false,
  onBlur: () => {},
  onClick: () => {},
  onRowChange: () => {},
  paginated: false,
  removeItem: () => {},
  repeatHeaders: false,
  sections: {},
  setInfo: () => {},
  setWarning: () => {},
  sortColumn: () => {},
};

FormTableBody.propTypes = {
  addItem: PropTypes.func,
  baseColumns: PropTypes.array,
  canAdd: PropTypes.bool,
  canDelete: PropTypes.bool,
  canInsert: PropTypes.bool,
  canSort: PropTypes.bool,
  className: PropTypes.string,
  collapse: PropTypes.func,
  collapsed: PropTypes.object,
  collapsibleRows: PropTypes.bool,
  collapsibleText: PropTypes.string,
  context: PropTypes.object.isRequired,
  currentIndex: PropTypes.number,
  fieldNameList: PropTypes.array,
  form: PropTypes.object.isRequired,
  isSectionHidden: PropTypes.func,
  manager: PropTypes.object.isRequired,
  minSize: PropTypes.number,
  numberedRows: PropTypes.bool,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onRowChange: PropTypes.func,
  removeItem: PropTypes.func,
  repeatHeaders: PropTypes.bool,
  sections: PropTypes.object,
  setInfo: PropTypes.func,
  setWarning: PropTypes.func,
  sortColumn: PropTypes.func,
};

export default withFormContext(FormTableBody);
